import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Desktop(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Desktop", sx, viewBox, children: [
    /* @__PURE__ */ jsx("path", { d: "M29 38H19l1-6h8l1 6Z", fill: theme.vars.palette.primary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M41.1 32.2059H6.9c-1.045 0-1.9-.8206-1.9-1.8235V10.3235C5 9.32059 5.855 8.5 6.9 8.5h34.2c1.045 0 1.9.82059 1.9 1.8235v20.0589c0 1.0029-.855 1.8235-1.9 1.8235ZM32.55 38.5h-17.1c-.57 0-.95-.3647-.95-.9118 0-.547.38-.9117.95-.9117h17.1c.57 0 .95.3647.95.9117 0 .5471-.38.9118-.95.9118Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M7 10h34v21H7V10Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M32.3529 14.4287h-5.647c-.1872 0-.3668-.0753-.4992-.2093-.1323-.1339-.2067-.3156-.2067-.5051 0-.1894.0744-.3711.2067-.5051.1324-.1339.312-.2092.4992-.2092h5.647c.1873 0 .3668.0753.4992.2092.1324.134.2067.3157.2067.5051 0 .1895-.0743.3712-.2067.5051-.1324.134-.3119.2093-.4992.2093Zm4.9412 4.2859H26.7059c-.1872 0-.3668-.0752-.4992-.2092-.1323-.1339-.2067-.3156-.2067-.5051 0-.1894.0744-.3711.2067-.5051.1324-.134.312-.2092.4992-.2092h10.5882c.1872 0 .3668.0752.4992.2092.1323.134.2067.3157.2067.5051 0 .1895-.0744.3712-.2067.5051-.1324.134-.312.2092-.4992.2092Zm-9.1765 4.286h-1.4117c-.1872 0-.3668-.0752-.4992-.2092-.1323-.134-.2067-.3157-.2067-.5051 0-.1895.0744-.3712.2067-.5051.1324-.134.312-.2092.4992-.2092h1.4117c.1873 0 .3668.0752.4992.2092.1324.1339.2067.3156.2067.5051 0 .1894-.0743.3711-.2067.5051s-.3119.2092-.4992.2092Zm6.3579 4.5175.2026-2.8788 2.8447-.205c.1182-.0134.2286-.0662.3139-.15.0853-.0839.1406-.1941.1571-.3132.0166-.1192-.0064-.2406-.0655-.345-.0591-.1044-.1508-.186-.2608-.2319l-5.9851-2.4944c-.0979-.0408-.2054-.0514-.3092-.0304-.1038.0209-.1991.0725-.2739.1483-.0748.0757-.1258.1721-.1465.2771-.0208.105-.0103.2139.03.3129l2.465 6.0568c.0453.1112.1259.2041.2291.2639.1032.0597.2231.0831.3409.0663.1177-.0168.2266-.0727.3095-.159s.135-.1981.1482-.3176Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Desktop.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Desktop"
};
validateTidalLicense();
export {
  Desktop
};
//# sourceMappingURL=Desktop.js.map
